import {StringUtils} from "@shared/util/general/string-utils";

export interface CustomizationProperty {
  name: string;
  value: any;
}

export type SupportedPropertyValueType = 'boolean' | 'string' | 'number';

export namespace CustomizationProperty {
  export function toFlatList(customizationProperties: Map<string, any> | null): CustomizationProperty[] {
    return customizationProperties
      ? Array.from(customizationProperties.entries(),
        ([name, value]) => ({name, value: value?.toString() ?? null}))
      : [];
  }

  export function toMap(customizationProperties: CustomizationProperty[] | null,
                        propertyTypesByName?: Map<string, SupportedPropertyValueType>): Map<string, any> {
    return new Map(customizationProperties?.map(({name, value}): [string, any] =>
      [name, fromApi(value, propertyTypesByName?.get(name) ?? 'string')]) ?? []);
  }

  // The API represents every property value as a string, so non-string types are parsed on read and stringified on write
  function fromApi(value: any, propertyType: SupportedPropertyValueType): any {
    switch (propertyType) {
      case 'boolean':
        return StringUtils.parseBoolean(value);
      case 'number':
        return Number(value);
      default:
        return value;
    }
  }
}
